module.exports = __webpack_public_path__ + "img/autospin_btn.65bf52ed.png";